<template>
  <div class="s_flex_ali m-b-20">
    <p class="width-119 text-ar">商品信息：</p>
    <a-card-meta :title="form.name">
      <template #avatar>
        <img :src="info.picdomain+'/'+form.image" alt="" style="width:50px;height: 50px;object-fit:cover">
      </template>
      <template #description>
        <span v-if='form.price_type == 2'>{{form.price}}元+</span>
        <span>{{form.point}}积分</span>
      </template>
    </a-card-meta>
  </div>
  <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
    <a-form-item ref="" label="库存" name="">
      <a-input-number class="width50" v-model:value="form.use_exchange_num" placeholder='请输入可兑换数量' :min="1" v-if='form.spec_type == 1'/>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='sku_sn' :columns='columns' :data-source='form.sku' v-else>
        <template v-slot:info="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+record.image_url" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>{{record.spec_value || record.sku_value}}</template>
          </a-card-meta>
        </template>
        <template v-slot:stock="{ record }">
          <a-input-number class='width100' v-model:value="record.use_exchange_num" placeholder='请输入数量' :min="0" :precision='0' />
        </template>
      </a-table>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 7, offset: 3 }">
      <a-button type="primary" @click="onSubmit">
        保存
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import { editGiftPrice, editGiftStock } from "@/api/integralShop";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defForm = {
    id: '',
    spec_type:1,
    use_exchange_num: '',
    sku:[]
  }
  export default {
    name: 'editStock',
    components: {},
    props: {
      item: {
        type: Object
      }
    },
    setup(props, { emit }) {
      const form = ref({ ...defForm });
      const state = reactive({
        info: store.state.user.info,
        labelCol: { span: 3 },
        wrapperCol: { span: 18 },
        columns: [
          {
            title: "规格信息",
            dataIndex: "info",
            key: "info",
            slots: { customRender: "info" },
          },
          {
            title: "规格库存",
            dataIndex: "stock",
            key: "stock",
            slots: { customRender: "stock" },
          },
        ]
      });
      const ruleForm = ref()
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          const hide = message.loading('正在加载中...', 0);
          let res = await editGiftStock({...form.value,sku : form.value.spec_type == 1 ? '' : form.value.sku}).then(res => res.data).catch((error) => error);
          if (iscode(res)) {
            message.success(res.msg);
            emit("submit");
          } else {
            message.error(res.msg);
          }
          setTimeout(hide);
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        form.value = JSON.parse(JSON.stringify(props.item))
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
      }
    }
  }
</script>